// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer--WNcNY","Footer-copyright":"Footer-copyright--2a7oW"};